import {InvoiceStatusTypes} from "../../provider/ProviderManageInvoices/consts";

export const findInvoiceWithDelivery = (deliveryId, invoices) => {
    if (!invoices?.length || !deliveryId) {
        return null;
    }

    // Filter out declined invoices, similar to findInvoiceWithOrder
    return invoices.find(
        invoice => invoice.deliveries?.includes(deliveryId) && invoice.status !== InvoiceStatusTypes.DECLINED
    );
};

export const getSummaryData = deliveries => {
    if (!deliveries?.length) {
        return {
            deliveryPrice: 0,
            totalPrice: 0,
            totalDeliveryProviderDiscount: 0
        };
    }

    return deliveries.reduce(
        (acc, delivery) => {
            const price = delivery.price ?? 0;
            const totalPrice = price - (delivery?.order?.deliveryProviderDiscount ?? 0);
            const totalDeliveryProviderDiscount = delivery?.order?.deliveryProviderDiscount ?? 0;

            return {
                deliveryPrice: (acc.deliveryPrice ?? 0) + price,
                totalPrice: (acc.totalPrice ?? 0) + totalPrice,
                totalDeliveryProviderDiscount: (acc?.totalDeliveryProviderDiscount ?? 0) + totalDeliveryProviderDiscount
            };
        },
        {deliveryPrice: 0, totalPrice: 0, totalDeliveryProviderDiscount: 0}
    );
};
